'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jurisdictions_constants = require('./jurisdictions.constants.js');
var welcomeNotification = require('./util/welcome-notification.js');
var sow_utils = require('./util/sow.utils.js');



exports.INITIAL_CASH_BALANCE_KEY = jurisdictions_constants.INITIAL_CASH_BALANCE_KEY;
Object.defineProperty(exports, 'Jurisdiction', {
	enumerable: true,
	get: function () {
		return jurisdictions_constants.Jurisdiction;
	}
});
exports.SESSION_START_TIME_KEY = jurisdictions_constants.SESSION_START_TIME_KEY;
exports.isAGCO = jurisdictions_constants.isAGCO;
exports.isDGOJ = jurisdictions_constants.isDGOJ;
exports.isEMTA = jurisdictions_constants.isEMTA;
exports.isLOTBA = jurisdictions_constants.isLOTBA;
exports.isONJN = jurisdictions_constants.isONJN;
exports.isPAGCOR = jurisdictions_constants.isPAGCOR;
exports.isSGA = jurisdictions_constants.isSGA;
exports.isSweepstakes = jurisdictions_constants.isSweepstakes;
exports.isUKGC = jurisdictions_constants.isUKGC;
exports.getWelcomeNotificationKey = welcomeNotification.getWelcomeNotificationKey;
exports.getWelcomeNotificationOptions = welcomeNotification.getWelcomeNotificationOptions;
exports.getWelcomeNotificationParams = welcomeNotification.getWelcomeNotificationParams;
exports.getGracePeriodDaysLeft = sow_utils.getGracePeriodDaysLeft;
exports.isKYCRequestedByAML = sow_utils.isKYCRequestedByAML;
exports.shouldDisplayLinkToWithdraw = sow_utils.shouldDisplayLinkToWithdraw;
